import { render } from "./LoadingSpinnerImg.vue?vue&type=template&id=4b1c0c4a"
import script from "./LoadingSpinnerImg.vue?vue&type=script&lang=js"
export * from "./LoadingSpinnerImg.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__